/**
 * Quyết định "gửi số lượng nào lên máy chủ" — hàm thuần, kiểm được.
 *
 * Tách ra vì một LỖI THẬT tìm được khi bấm thử 15/09/2026: bảng chọn dòng hiện
 * hai dòng, cả hai điền sẵn số còn xuất được, người dùng chỉ sửa dòng đầu — và
 * hóa đơn lập ra chỉ có dòng đầu. Dòng thứ hai im lặng rơi mất, trong khi màn
 * hình vừa nói nó sẽ được xuất.
 *
 * Gốc rễ: ô nhập hiển thị `value[id] ?? remaining`, nhưng thứ gửi đi chỉ là
 * `value` — tức chỉ những dòng người dùng CHẠM VÀO. Mắt thấy một đằng, gửi đi
 * một nẻo. 766 test lúc đó không bắt được, vì không test nào chạm giao diện.
 */

export interface AllocatableLine {
  piItemId: string;
  remaining: number;
}

/**
 * Những dòng CÒN THIẾU trong lựa chọn, kèm số mặc định của chúng.
 *
 * Trả về `null` khi không thiếu gì — để chỗ gọi khỏi tạo một object mới mỗi
 * lần dựng lại và rơi vào vòng lặp cập nhật.
 */
export function seedMissingAllocations(
  lines: AllocatableLine[],
  value: Record<string, number>,
): Record<string, number> | null {
  const missing = lines.filter((l) => l.remaining > 0 && value[l.piItemId] === undefined);
  if (missing.length === 0) return null;
  return { ...value, ...Object.fromEntries(missing.map((l) => [l.piItemId, l.remaining])) };
}
